<app-hero></app-hero>
<div
    class="container mt-4"
    *ngIf="setupService.layout?.components?.ratingBlock || setupService.layout?.components?.affiliationCall?.value"
>
    <div class="row justify-content-center">
        <div class="col-md-6" >
            <app-rating-cta></app-rating-cta>
        </div>
        <div class="col-md-6" *ngIf="setupService.layout?.components?.affiliationCall?.value === '1'">
            <app-call-to-action
                [title]="setupService.layout?.components?.affiliationCall?.title"
                [description]="setupService.layout?.components?.affiliationCall?.text"
                [buttonText]="setupService.layout?.components?.affiliationCall?.title"
                [link]="loggedIn ? '/' + setupService.layout?.components?.affiliationCall?.link : '/auth/login'"
                [queryParams]="
                    loggedIn ? {} : { redirect: '/' + setupService.layout?.components?.affiliationCall?.link }
                "
            ></app-call-to-action>
        </div>
    </div>
</div>
<div class="container mt-4 mb-4">
    <div class="row">
        <ng-container [ngSwitch]="setupService.layout?.components?.tournamentBlock">
            <ng-container *ngSwitchCase="1">
                <ng-container *ngTemplateOutlet="tournamentsTabs"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="2">
                <ng-container *ngTemplateOutlet="tournamentsCourses"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>
<div class="container">
    <div class="col-12 mb-2">
        <app-shared-partner [position]="'MAIN_PAGE'" [formatType]="'BNTENNISTOOL02'" [padding]="2"></app-shared-partner>
    </div>
</div>
<app-shared-match-program *ngIf="setupService.layout?.components?.programCentral == '1'"></app-shared-match-program>
<app-recent-news></app-recent-news>
<div class="container">
    <div class="col-12 mb-2">
        <app-shared-partner
            [formatType]="'BNTENNISTOOL05'"
            [position]="'TOURNAMENTS'"
            [chunks]="4"
            [direction]="'horizontal'"
            [fullWidth]="true"
        ></app-shared-partner>
    </div>
</div>

<app-featured-rankings></app-featured-rankings>
<app-recent-videos></app-recent-videos>
<app-featured-champions *ngIf="setupService.layout?.components?.rankingChampions == '1'"></app-featured-champions>

<!-- Template no qual é exibido torneios separados por abas -->
<ng-template #tournamentsTabs>
    <div class="col-12 mb-2">
        <app-featured-tournaments type="1"></app-featured-tournaments>
    </div>
</ng-template>
<!-- Template no qual é exibido torneios e cursos -->
<ng-template #tournamentsCourses>
    <div [ngClass]="['mb-2', 'mb-lg-0', (homeService.hasEvents | async) ? 'col-lg-8' : 'col-lg-12']">
        <app-featured-tournaments type="2"></app-featured-tournaments>
    </div>

    <div class="col-lg-4 mt-3 mt-md-0" *ngIf="homeService.hasEvents | async">
        <app-featured-events></app-featured-events>
    </div>
</ng-template>
